var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.63 19.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #ffd715;\n            }\n\n            .cls-2 {\n                fill: #ffcc01;\n            }\n\n            .cls-3 {\n                opacity: 0.35;\n            }\n\n            .cls-4 {\n                fill: #fcbd11;\n            }\n\n            .cls-5 {\n                fill: #ffdb53;\n            }\n\n            .cls-6 {\n                fill: #bf7008;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 9.82,
    cy: 9.9,
    rx: 9.82,
    ry: 9.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 9.82,
    cy: 9.9,
    rx: 8.33,
    ry: 8.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.86,3.33a8.42,8.42,0,0,1-7,12.93A8.3,8.3,0,0,1,2.48,15a8.32,8.32,0,0,0,15.35-4.53A8.42,8.42,0,0,0,13.86,3.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2.63,10.27A7.34,7.34,0,0,1,15.81,5.75,7.34,7.34,0,0,0,2.08,9.44,7.43,7.43,0,0,0,3.61,14,7.35,7.35,0,0,1,2.63,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M13.16,9.11V6.39c0-.78-.51-1.17-1.49-1.17H8c-1,0-1.49.39-1.49,1.17V13.3c0,.76.5,1.13,1.49,1.13h3.7c1,0,1.49-.37,1.49-1.13V10h-3v2.15a0,0,0,0,1,0,0H9.48a0,0,0,0,1,0,0V7.56a0,0,0,0,1,0,0h.67a0,0,0,0,1,0,0V9.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 8.24,
    y: 4.15,
    width: 2.97,
    height: 1.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 8.24,
    y: 14.44,
    width: 2.97,
    height: 1.22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.e3a0a642.svg";
export { ForwardRef as ReactComponent };